import { useDispatch, useSelector } from "react-redux";
import { FaRegEyeSlash, FaRegEye, FaRegTrashAlt  } from "react-icons/fa";
import { StaffChangeHidden, StaffOneDaySumHours, StaffUnHidden, setStaffDeletedStatus } from "../../Reducer/StaffSlice";
import { useState } from "react";
import axios from "axios";
import { setOpenModalAddStaff, setOpenRevenue, setOpenStaffManagment } from "../../Reducer/ModalSlice";
import { IoClose } from "react-icons/io5"
import { addEditStaff } from "../../Reducer/AddStaffSlice";

function StaffManagment() {
    const StaffSelectedCityArray = useSelector(state => state.StaffSlice.StaffSelectedCityArray)

    const RevenueArray = useSelector(state => state.RevenueSlice.RevenueArray)

    const SelectedMonth = useSelector(state => state.MonthSlice.SelectedMonth)

    const User = useSelector(state => state.UserSlice.User)
    const Server = useSelector(state => state.UserSlice.Server)

    const dispatch = useDispatch()

    const [ModalChangeHidden, setModalChangeHidden] = useState(false)
    const [ModalDeletedStaff, setModalDeletedStaff] = useState(false)
    const [StaffSaver, setStaffSaver] = useState()
    const [CancelTouch, setCancelTouch] = useState(false)

    const handleClickDeleteStaffButton = async (event) => {
        if(event.type === 'touchend')
            event.preventDefault()
        
        await dispatch(setStaffDeletedStatus(StaffSaver.id))
        axios.put(Server + "staff/" + StaffSaver.id, {
            Deleted: String(parseInt(new Date().getMonth()) + 1) + '.' + String(new Date().getFullYear())
        }, {
        headers: {
            Authorization: 'Bearer ' + User.jwt,
        },
        })
        setStaffSaver()
        setModalDeletedStaff(false)
        RevenueArray.map((el) => {
            dispatch(StaffOneDaySumHours(el.id))
            return(el)
        })
    } 

    return(
        <div
        className="ModalGlobalDiv"
        >
            <div
            className="ModalStaffManagmentMainDiv"
            >
                <div
                className="ModalInformationDiv"
                >
                    <div
                    className="ModalInformationTextDiv"
                    >
                        Управление
                    </div>
                    <button
                    className="CloseModalIconDiv"
                    onClick={(() =>{
                        dispatch(setOpenStaffManagment(false))
                        dispatch(setOpenRevenue(true))
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) =>{
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            dispatch(setOpenStaffManagment(false))
                            dispatch(setOpenRevenue(true))
                        }
                    })}
                    >
                        <IoClose
                        className="CloseModalIcon"
                        />
                    </button>
                </div>
                <div
                className="ModalStaffManagmentDiv"
                >
                    {StaffSelectedCityArray.map((el) =>                     
                        <div
                        key={el.id}
                        className="OneStaffManagmentDiv"
                        >
                            <div>
                            {el.Deleted === 'false' ? el.Post + " " + el.FIO : el.Post + " " + el.FIO + ' удален ' + el.Deleted} 
                            </div>
                            <div
                            className="DivFlex Gap Align-items_center"
                            >
                                {el.Deleted === 'false' &&
                                <button
                                className="ChangePostButton"
                                onClick={(() => {
                                    dispatch(setOpenModalAddStaff(true))
                                    dispatch(setOpenStaffManagment(false))
                                    dispatch(addEditStaff(el))
                                    dispatch(setOpenRevenue(false))
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                    {
                                        dispatch(setOpenModalAddStaff(true))
                                        dispatch(setOpenStaffManagment(false))
                                        dispatch(addEditStaff(el))
                                        dispatch(setOpenRevenue(false))
                                    }
                                })}
                                >
                                    Изменить
                                </button>
                                }

                                {el.Deleted === 'false' && 
                                <button
                                className="FilterButtonAR"
                                onClick={(() => {
                                    setModalDeletedStaff(true)
                                    setStaffSaver(el)
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                    {
                                        setModalDeletedStaff(true)
                                        setStaffSaver(el)
                                    }
                                })}
                                >
                                    <FaRegTrashAlt/>
                                </button>}

                                <button
                                className="FilterButtonAR"
                                onClick={(async () => {
                                    if(SelectedMonth.BlockEdit !== true)
                                    {
                                        if(el.Hidden !== true)
                                        {
                                            setStaffSaver(el)
                                            setModalChangeHidden(true)
                                        }
                                        else
                                        {
                                            await dispatch(StaffUnHidden(el.id))
                                            await axios.put(Server + "staffofthemonths/" + el.idHourses, {
                                            Hidden: false
                                            }, {
                                                headers: {
                                                Authorization: 'Bearer ' + User.jwt,
                                                },
                                            })
                                            RevenueArray.map((el) => {
                                                dispatch(StaffOneDaySumHours(el.id))
                                                return(el)
                                            })
                                        }
                                    }
                                    else
                                    {
                                        alert('Ошибка! Редактирование данного месяца закрыто!')
                                    }
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={(async (event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                    {
                                        if(SelectedMonth.BlockEdit !== true)
                                        {
                                            if(el.Hidden !== true)
                                            {
                                                setStaffSaver(el)
                                                setModalChangeHidden(true)
                                            }
                                            else
                                            {
                                                await dispatch(StaffUnHidden(el.id))
                                                await axios.put(Server + "staffofthemonths/" + el.idHourses, {
                                                Hidden: false
                                                }, {
                                                    headers: {
                                                    Authorization: 'Bearer ' + User.jwt,
                                                    },
                                                })
                                                RevenueArray.map((el) => {
                                                    dispatch(StaffOneDaySumHours(el.id))
                                                    return(el)
                                                })
                                            }
                                        }
                                        else
                                        {
                                            alert('Ошибка! Редактирование данного месяца закрыто!')
                                        }
                                    }
                                })}
                                >
                                    {el.Hidden !== true ? 
                                    <FaRegEye/> 
                                    : 
                                    <FaRegEyeSlash/>
                                    }
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                    {ModalChangeHidden &&
                    <div
                    className="ModalChangeHiddenGlobalDiv"
                    >
                        <div
                        className="ModalChangeHiddenMainDiv"
                        >
                            <div>
                            {'Сотрудник ' + StaffSaver.FIO + ' будет скрыт в текущем месяце, а информация о его сменах за этот месяц будет обнулена' }
                            </div>
                            <div
                            className="ModalChangeHiddenButtonsDiv"
                            >
                                <button
                                className="ModalChangeHiddenButton Cancle"
                                onClick={(() => {
                                    setStaffSaver()
                                    setModalChangeHidden(false)
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                    {
                                        setStaffSaver()
                                        setModalChangeHidden(false)
                                    }
                                })}
                                >
                                    Отмена
                                </button>
                                <button
                                className="ModalChangeHiddenButton Ok"
                                onClick={(async () => {
                                    await dispatch(StaffChangeHidden(StaffSaver.id))
                                    var PusherStaff = ''
                                    await StaffSelectedCityArray.map((el) => {
                                        if(el.id === StaffSaver.id)
                                            {
                                                PusherStaff = el
                                            }
                                        return(el)
                                    })
                                    var HoursArray = []
                                    PusherStaff.Hours.map((a) => {
                                        HoursArray = String(HoursArray) + String(a.Value) + '_'
                                        return(a)
                                    })
                                    HoursArray = HoursArray.slice(0, -1);
                                    axios.put(Server + "staffofthemonths/" + PusherStaff.idHourses, {
                                        Hours: HoursArray,
                                        Additional: '0_0_0_0',
                                        Hidden: true
                                    }, {
                                        headers: {
                                          Authorization: 'Bearer ' + User.jwt,
                                        },
                                      })
                                    setStaffSaver()
                                    setModalChangeHidden(false)
                                    RevenueArray.map((el) => {
                                        dispatch(StaffOneDaySumHours(el.id))
                                        return(el)
                                    })
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={(async (event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                    {
                                        await dispatch(StaffChangeHidden(StaffSaver.id))
                                        var PusherStaff = ''
                                        await StaffSelectedCityArray.map((el) => {
                                            if(el.id === StaffSaver.id)
                                                {
                                                    PusherStaff = el
                                                }
                                            return(el)
                                        })
                                        var HoursArray = []
                                        PusherStaff.Hours.map((a) => {
                                            HoursArray = String(HoursArray) + String(a.Value) + '_'
                                            return(a)
                                        })
                                        HoursArray = HoursArray.slice(0, -1);
                                        axios.put(Server + "staffofthemonths/" + PusherStaff.idHourses, {
                                            Hours: HoursArray,
                                            Additional: '0_0_0_0',
                                            Hidden: true
                                        }, {
                                            headers: {
                                            Authorization: 'Bearer ' + User.jwt,
                                            },
                                        })
                                        setStaffSaver()
                                        setModalChangeHidden(false)
                                        RevenueArray.map((el) => {
                                            dispatch(StaffOneDaySumHours(el.id))
                                            return(el)
                                        })
                                    }
                                })}
                                >
                                    Ок
                                </button>
                            </div>
                        </div>
                    </div>
                    }

                    {ModalDeletedStaff &&
                    <div
                    className="ModalChangeHiddenGlobalDiv"
                    >
                        <div
                        className="ModalChangeHiddenMainDiv"
                        >
                            <div>
                            {'Сотрудник ' + StaffSaver.FIO + ' и данные о нем будут удалены' }
                            </div>
                            <div
                            className="ModalChangeHiddenButtonsDiv"
                            >
                                <button
                                className="ModalChangeHiddenButton Cancle"
                                onClick={(() => {
                                    setStaffSaver()
                                    setModalDeletedStaff(false)
                                })}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={((event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                    {
                                        setStaffSaver()
                                        setModalDeletedStaff(false)
                                    }
                                })}
                                >
                                    Отмена
                                </button>
                                <button
                                className="ModalChangeHiddenButton Ok"
                                onClick={handleClickDeleteStaffButton}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={(event) => {
                                    event.preventDefault()
                                    if(!CancelTouch)
                                        handleClickDeleteStaffButton(event)
                                }}
                                >
                                    Ок
                                </button>
                            </div>
                        </div>
                    </div>
                    }
            </div>
        </div>
    )
}

export default StaffManagment;
